// =============================================================================
// DASHBOARD OVERVIEW - MOCK DATA
// =============================================================================

import type { KpiMetrics, TopPerformer, CallRecord, MissedCallRecord, DashboardData, FilterOptions, PaginationInfo } from './types'

export const mockKpiMetrics: KpiMetrics = {
  totalCalls: {
    total: 99,
    inbound: 68,
    outbound: 31,
  },
  bookings: {
    total: 46,
    conversionRate: 76.6,
    opportunities: 60,
    booked: 46,
  },
  avgQualityScore: {
    newOpps: 78.2,
    existing: 72.4,
    insurance: 75.0,
  },
  missedCalls: {
    total: 0,
    changePercent: 0,
  },
}

export const mockTopPerformers: TopPerformer[] = [
  { rank: 1, name: 'Boris R.', calls: 29, bookings: 15, score: 88 },
  { rank: 2, name: 'Kevin R.', calls: 29, bookings: 14, score: 82 },
  { rank: 3, name: 'Denys M.', calls: 17, bookings: 8, score: 76 },
]

export const mockCalls: CallRecord[] = [
  {
    id: 1,
    time: '10:42 AM',
    direction: 'inbound',
    brand: 'TopServ Appliance',
    brandColor: 'blue',
    csrName: 'Boris R.',
    ringTime: '5s',
    result: 'booked',
    leadType: 'new',
    isNewOpportunity: true,
    score: 92,
    hasRecording: true,
    summary: 'Customer asked about GE fridge repair co...',
  },
  {
    id: 2,
    time: '10:15 AM',
    direction: 'outbound',
    brand: 'TopServ HVAC',
    brandColor: 'green',
    csrName: 'Kevin R.',
    ringTime: null,
    result: 'existing',
    leadType: 'existing',
    isNewOpportunity: false,
    score: 78,
    hasRecording: true,
    summary: 'Follow-up on AC maintenance request. Cli...',
  },
  {
    id: 3,
    time: '09:55 AM',
    direction: 'inbound',
    brand: 'Comm. Appliance Repair',
    brandColor: 'orange',
    csrName: 'Denys M.',
    ringTime: '12s',
    result: 'lost_opp',
    leadType: 'new',
    isNewOpportunity: true,
    score: 45,
    hasRecording: true,
    summary: 'Caller needed urgent commercial oven re...',
  },
  {
    id: 4,
    time: '09:30 AM',
    direction: 'inbound',
    brand: 'TopServ Appliance',
    brandColor: 'blue',
    csrName: 'Boris R.',
    ringTime: '8s',
    result: 'inquiry',
    leadType: null,
    isNewOpportunity: false,
    score: 85,
    hasRecording: true,
    summary: 'General questions about warranty covera...',
  },
  {
    id: 5,
    time: '09:12 AM',
    direction: 'inbound',
    brand: 'TopServ HVAC',
    brandColor: 'green',
    csrName: 'Kevin R.',
    ringTime: '3s',
    result: 'booked',
    leadType: 'new',
    isNewOpportunity: true,
    score: 98,
    hasRecording: true,
    summary: 'Furnace making loud noises. Immediate di...',
  },
  {
    id: 6,
    time: '08:45 AM',
    direction: 'inbound',
    brand: 'Comm. Appliance Repair',
    brandColor: 'orange',
    csrName: 'Oleksandr S.',
    ringTime: '6s',
    result: 'not_booked',
    leadType: null,
    isNewOpportunity: false,
    score: 60,
    hasRecording: true,
    summary: 'Location is outside of service radius (Boul...',
  },
  {
    id: 7,
    time: '08:22 AM',
    direction: 'inbound',
    brand: 'TopServ Appliance',
    brandColor: 'blue',
    csrName: 'Kevin R.',
    ringTime: '4s',
    result: 'booked',
    leadType: 'new',
    isNewOpportunity: true,
    score: 91,
    hasRecording: true,
    summary: 'Dryer not heating up. Scheduled diagnost...',
  },
]

export const mockFilters: FilterOptions = {
  period: 'today',
  result: 'all',
  csr: 'any',
  scoreRange: 'all',
  search: '',
}

export const mockPagination: PaginationInfo = {
  currentPage: 1,
  totalPages: 15,
  totalItems: 99,
  itemsPerPage: 7,
}

export const mockMissedCalls: MissedCallRecord[] = []

export const mockDashboardData: DashboardData = {
  kpiMetrics: mockKpiMetrics,
  topPerformers: mockTopPerformers,
  calls: mockCalls,
  missedCalls: mockMissedCalls,
  pagination: mockPagination,
  filters: mockFilters,
}

// CSR options for filter dropdown
export const csrOptions = [
  { value: 'any', label: 'Any' },
  { value: 'boris-r', label: 'Boris R.' },
  { value: 'kevin-r', label: 'Kevin R.' },
  { value: 'denys-m', label: 'Denys M.' },
  { value: 'oleksandr-s', label: 'Oleksandr S.' },
]

// Result options for filter dropdown (must match server-side values from overview_controller.rb)
export const resultOptions = [
  { value: 'all', label: 'All' },
  { value: 'booked', label: 'Booked' },
  { value: 'existing', label: 'Existing Customer' },
  { value: 'not_booked', label: 'Not Booked' },
]

// Score range options for filter dropdown
export const scoreOptions = [
  { value: 'all', label: 'All' },
  { value: 'analyzed', label: 'Analyzed Only' },
  { value: 'high', label: 'High (85+)' },
  { value: 'medium', label: 'Medium (60-84)' },
  { value: 'low', label: 'Low (<60)' },
]

// Period options for date picker
export const periodOptions = [
  { value: 'today', label: 'Today' },
  { value: 'yesterday', label: 'Yesterday' },
  { value: 'week', label: 'This Week' },
  { value: 'month', label: 'This Month' },
]
